import { axiosInstance } from "../axiosInstance";

const getProfile = () => axiosInstance.get(`agent/profile`).then(res => res?.data)
const updateProfile = (data) => axiosInstance.post(`agent/profile`, data, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})

export { getProfile, updateProfile }
